import AreaFilter from "./area-filter";
import AreaList from "./area-list";
import CreateAreaForm from "./create-area-form";
import {useDispatch, useSelector} from "react-redux";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {useEffect} from "react";
import {setToolsInitialState} from "../../reducers/tools.reducer";
import {setAreaSelectedRowKeys} from "../../reducers/area.reducer";
import {SORT_LIST_AREA} from "../../utils/sort-list";
import {useEffectAfterMount} from "../../services/useEffectAfterMount";

const AreaPage = () => {
    const dispatch = useDispatch()
    const defaultSort = SORT_LIST_AREA?.find(item => item.isDefault)
    const getOrderBy = defaultSort?.key.split('_')
    const {
        currentPage,
        pageSize,
        orderBy,
        sort,
        searchKey,
        reload
    } = useSelector(state => state.toolsReducer)
    const queryParams = {
        page: currentPage,
        perPage: pageSize,
        orderBy: !!orderBy ? orderBy : getOrderBy[0],
        orderType: sort,
        search: searchKey
    }
    const {
        data: response,
        fetching: getAreaList,
        isLoading
    } = useFetch(API.AREA_LIST, queryParams, {isWithTotalData: true})

    useEffect(() => {
        return () => {
            dispatch(setToolsInitialState())
            dispatch(setAreaSelectedRowKeys([]))
        }
    }, [])

    useEffectAfterMount(() => {
        getAreaList()
    }, [currentPage, pageSize, orderBy, sort, searchKey, reload])

    return (
        <div className={"col px-10"}>
            <div className={"row justify-between items-center"}>
                <AreaFilter/>
                <CreateAreaForm/>
            </div>
            <AreaList dataSource={response?.data?.result ?? []} isLoading={isLoading}/>
        </div>
    )
}

export default AreaPage